import React from "react";

import { IconErrorOutlined, IconMainMenuMonitors } from "~/components/icon";

import { useQueryMonitor } from "../../queries/monitors";
import { DrawerTitle, ExplorationDrawer } from "../react/drawer/ExplorationDrawer";
import { Timestamp } from "../timestamp";

import { MonitorOutputDrawerContent } from "./monitor-output-drawer-content";
import type { MonitorOutputDrawerState } from "./monitor-output-drawer-state";

export interface MonitorOutputDrawerProps {
	when: undefined | MonitorOutputDrawerState;
}

export const MonitorOutputDrawer: React.FC<MonitorOutputDrawerProps> = ({ when }) => (
	<ExplorationDrawer
		headerActions={({ lastSuccessfulRunTimestamp }) =>
			lastSuccessfulRunTimestamp != null && <Timestamp time={lastSuccessfulRunTimestamp} />
		}
		headerTitle={({ monitor }) =>
			monitor.type === "MONITOR" ? (
				<MonitorOutputDrawerHeader monitorId={monitor.monitorId} />
			) : (
				<MonitorOutputDrawerName title="Mapped health states" />
			)
		}
		when={when}
	>
		{(config) => <MonitorOutputDrawerContent {...config} />}
	</ExplorationDrawer>
);

const MonitorOutputDrawerHeader: React.FC<{
	monitorId: number;
}> = ({ monitorId }) => {
	const { isError, data } = useQueryMonitor(monitorId);

	if (isError) {
		return (
			<DrawerTitle
				icon={<IconErrorOutlined className="text-red-500" height={20} width={20} />}
				title="Error while loading monitor details"
			/>
		);
	}

	return <MonitorOutputDrawerName title={data?.name} typeOfData="Produced health states" />;
};

const MonitorOutputDrawerName: React.FC<{
	title: undefined | string;
	typeOfData?: string;
}> = (props) => (
	<DrawerTitle
		icon={<IconMainMenuMonitors className="shrink-0 stroke-[1.5px] text-grey-800" height={20} width={20} />}
		{...props}
	/>
);
